import styled from "styled-components";
import "../../../../styles/variables.css";

export const OnboardingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
`;

export const OnboardingInformation = styled.div`
  text-align: center;
  span {
    margin: 10px 0 0 0;
    font-size: var(--fs14);
  }
`;

export const OnboardingInfoText = styled.span`
  text-align: center;
`;

export const ViewFAQ = styled.div`
  width: 80%;
  height: 66px;
  margin-bottom: 40px;
  border-top: 1px solid var(--border-light);
  border-bottom: 1px solid var(--border-light);
  span {
    color: var(--main-text-color);
    margin: 0 5px;
  }
  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }
`;

export const LogoContainer = styled.div`
  position: relative;
  margin-bottom: 15px;
  img {
    width: 56px;
    height: 56px;
  }
`;

export const Divider = styled.div`
  width: 50px;
  height: 2px;
  border-top: 2px dashed var(--black);
`;
